module.exports = __webpack_public_path__ + "static/media/bf.4ca3a728.svg";